function homeSlider() {
  const homeSliderWrapper = document.querySelector('.home-hero__slider');
  let slideIndex = 0;
  let autoplayInterval = null;
  let touchStartX = 0;
  let touchEndX = 0;
  let isTransitioning = false;
  let parallaxInstance = null;
  const canAutoPlay = homeSliderWrapper.getAttribute('data-autoplay');

  function init() {
    const slides = document.querySelectorAll('.home-hero__slide');

    if (slides.length > 1 && canAutoPlay === 'true') {
      addPaginationButtons();

      // add event listeners to slider if touch exists
      if ('ontouchstart' in window || navigator.maxTouchPoints) {
        homeSliderWrapper.addEventListener('touchstart', onTouchStart, { passive: true });
        homeSliderWrapper.addEventListener('touchmove', onTouchMove, { passive: true });
        homeSliderWrapper.addEventListener('touchend', onTouchEnd, { passive: true });
      }

      // add event listener to stop autoplay when tab is not active
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          onStopAutoplay();
        } else {
          onAutoplay();
        }
      });

      onAutoplay();
    }

    // Parallax scene for custom slides on desktop
    const animalSlides = [
      { animal: 'snow-leopard', usesCustomContainer: true },
      {
        animal: 'koala',
        usesCustomContainer: true,
      },
    ];

    // Loop to activate each slide
    animalSlides.forEach((slide) => {
      onActivateHeroSlide(slide);
    });
  }

  // Generate pagination buttons based on number of slides
  function addPaginationButtons() {
    const paginationButtonsContainer = document.querySelector('.home-hero__slider-pagination');
    const slides = document.querySelectorAll('.home-hero__slide');

    slides.forEach(function pagination(slide, index) {
      const button = document.createElement('button');
      button.classList.add('home-hero__slider-pagination-button');
      button.setAttribute('data-index', index);
      button.setAttribute('aria-label', `Slide ${index}`);
      button.setAttribute('aria-current', 'false');
      if (index === 0) {
        button.classList.add('is-active');
        button.setAttribute('aria-current', 'true');
      }
      paginationButtonsContainer.appendChild(button);
    });

    // add event listeners to pagination buttons
    const paginationButtons = document.querySelectorAll('.home-hero__slider-pagination-button');
    paginationButtons.forEach(function paginationEvent(button) {
      button.addEventListener('click', onPaginationChange);
    });

    // Remove hidden attribute from pagination container
    paginationButtonsContainer.removeAttribute('hidden');
  }

  function onActivateHeroSlide({ animal, parallaxConfig = {}, usesCustomContainer }) {
    const slides = document.querySelectorAll('.home-hero__slide');
    const currentSlideContainer = document.querySelector(
      usesCustomContainer ? `.home-hero__custom-slide__container.--${animal}` : `.home-hero__${animal}-container`
    );

    if (currentSlideContainer) {
      parallaxInstance = new Parallax(currentSlideContainer, {
        hoverOnly: true,
        limitY: 10,
        limitX: 50,
        frictionX: 0.05,
        frictionY: 0.01,
        scalarX: 5,
        ...parallaxConfig,
      });

      if (slides.length > 1) {
        // Observer to check if sloth slide is active and enable/disable parallax
        const attrObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type !== 'attributes' && mutation.attributeName !== 'class') {
              return;
            }
            if (
              mutation.target.classList.contains('is-active') &&
              !mutation.target.classList.contains('is-prev-active')
            ) {
              parallaxInstance.enable();
            } else if (
              !mutation.target.classList.contains('is-prev-active') &&
              !mutation.target.classList.contains('is-active')
            ) {
              parallaxInstance.disable();
            }
          });
        });

        const slide = document.querySelectorAll(`.${animal}-slide`);
        slide.forEach((el) => attrObserver.observe(el, { attributes: true }));
      }
    }
  }

  function onTouchStart(event) {
    onStopAutoplay();
    touchStartX = event.touches[0].clientX;
    touchEndX = 0;
  }

  function onTouchMove(event) {
    onStopAutoplay();
    touchEndX = event.touches[0].clientX;
  }

  function onTouchEnd() {
    if (isTransitioning || touchEndX === 0) {
      return;
    }

    // handles swipe left and right but not scrolling up or down
    if (touchStartX - touchEndX > 50) {
      onNextSlide();
    } else if (touchStartX - touchEndX < -50) {
      onPrevSlide();
    }

    onAutoplay();
  }

  function onAutoplay() {
    autoplayInterval = setTimeout(() => {
      if (isTransitioning) {
        return;
      }
      onNextSlide();
      clearInterval(autoplayInterval);
    }, 8050);
  }

  function onStopAutoplay() {
    clearInterval(autoplayInterval);
  }

  function onPrevSlide() {
    isTransitioning = true;
    const slides = document.querySelectorAll('.home-hero__slide');
    let prevIndex = slideIndex - 1;

    if (prevIndex < 0) {
      prevIndex = slides.length - 1;
    }

    onUpdateIndex(prevIndex);
  }

  function onNextSlide() {
    isTransitioning = true;
    const slides = document.querySelectorAll('.home-hero__slide');
    let nextIndex = slideIndex + 1;

    if (nextIndex >= slides.length) {
      nextIndex = 0;
    }

    onUpdateIndex(nextIndex);
  }

  function onUpdateIndex(index) {
    const slides = document.querySelectorAll('.home-hero__slide');
    const activeSlide = document.querySelector('.home-hero__slide.is-active');
    const activePaginationButton = document.querySelector('.home-hero__slider-pagination-button.is-active');

    // remove active classes
    activeSlide.classList.add('is-prev-active');
    activePaginationButton.classList.remove('is-active');

    document.querySelector(`.home-hero__slider-pagination-button[data-index="${index}"]`).classList.add('is-active');

    // add active classes
    setTimeout(() => {
      activeSlide.classList.remove('is-prev-active');
      activeSlide.classList.remove('is-active');
      slides[index].classList.add('is-active');
      slideIndex = index;
    }, 500);

    setTimeout(() => {
      isTransitioning = false;
      if (canAutoPlay === 'true') {
        onAutoplay();
      }
    }, 1500);
  }

  function onPaginationChange(event) {
    onStopAutoplay();
    if (isTransitioning) {
      return;
    }
    isTransitioning = true;
    const button = event.currentTarget;
    const index = button.getAttribute('data-index');
    const slides = document.querySelectorAll('.home-hero__slide');
    const activeSlide = document.querySelector('.home-hero__slide.is-active');
    const activePaginationButton = document.querySelector('.home-hero__slider-pagination-button.is-active');

    // remove active classes
    activeSlide.classList.add('is-prev-active');
    activePaginationButton.classList.remove('is-active');

    // add active classes
    setTimeout(() => {
      isTransitioning = false;
      activeSlide.classList.remove('is-prev-active');
      activeSlide.classList.remove('is-active');
      slides[index].classList.add('is-active');

      if (canAutoPlay !== 'false') {
        onAutoplay();
      }
    }, 500);

    slideIndex += index;
    button.classList.add('is-active');
  }

  if (document.body.classList.contains('page-type-index')) {
    init();
  }
}

export default function HomeHeroSlider() {
  homeSlider();

  // Listen for block selection in editor.
  // This will update the selected block in the slider with active class so it can be styled in the editor
  if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', function shopifyEvent(event) {
      const selectedBlock = event.detail.blockId;
      const slide = document.querySelector(`.home-hero__slide.--${selectedBlock}`);
      if (slide) {
        const activeSlide = document.querySelector('.home-hero__slide.is-active');
        activeSlide.classList.remove('is-active');
        slide.classList.add('is-active');
        const paginationButtonsContainer = document.querySelector('.home-hero__slider-pagination');
        paginationButtonsContainer.setAttribute('hidden', true);
      }
    });
  }
}
